import { CacheAxiosResponse } from 'axios-cache-interceptor';

import { APIURL } from '@configurations/Settings';
import axios from '@helpers/Http/config';
import TokenStore from '../store/TokenStore';
import TokenService from '../service/TokenService';

const tokenService = new TokenService();

function CustomAppTokenErrorInterceptor () {
  const interceptor = axios.interceptors.response.use((response : CacheAxiosResponse) => {
    return response;
  }, async error => {
    try {
      if (error.config.url.includes(APIURL)) {
        if (error.response.status === 401) {
          axios.interceptors.response.eject(interceptor);
          return tokenService.GetTokenSilently('APP').then(response => {
            if (response) {
              console.log('new token');
              error.response.config.headers['Authorization'] = `Bearer ${TokenStore.getState().accessToken}`;
              return axios(error.response.config);
            } else {
              console.log('no token');
              TokenStore.getState().clearAccessToken();
            }
          }).catch(error => {
            TokenStore.getState().clearAccessToken();
          }).finally(() => {
            CustomAppTokenErrorInterceptor();
          })
        }
      }
      
    } catch (e) {
      console.error(e);
    }

    return Promise.reject(error);
  });
}

export default CustomAppTokenErrorInterceptor;